module.exports = __webpack_public_path__ + "static/paper-6df343e6d2d8532cfb71e9fe2febfe21.png";